// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.usermanagementapplicationpermission.RentalManagerUserManagementApplicationPermissionWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  NewApplicationManagerDto,
  RentalManagerApplicationManagerWebDto,
  RentalManagerNameDto,
  TransferApplicationManagerDto,
  UserManagementApplicationPermissionUserStatusDto,
} from '../..';

interface CreatePermissionRequestParams {
  userManagementCompanyId: string;
}
interface DismissPermissionRequestsParams {
  userManagementCompanyId: string;
}
interface GiveUserApplicationPermissionParams {
  userManagementCompanyId: string;
  userToken: string;
}
interface RemoveUserApplicationPermissionParams {
  userManagementCompanyId: string;
  userToken: string;
}

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_createApplicationManager_Path =
  '/api/web/v1/users/userManagementApplicationPermission/createApplicationManager';

/**
 * Set up Application Permissions for UM Company with new Application Manager
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_createApplicationManager = (
  postData: NewApplicationManagerDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, NewApplicationManagerDto, void>(
    {
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_createApplicationManager_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_Path =
  '/api/web/v1/users/userManagementApplicationPermission/createPermissionRequest';

/**
 * Create a permission request for the logged in user to a company
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest = (
  getParams: CreatePermissionRequestParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CreatePermissionRequestParams, never, RentalManagerNameDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_dismissPermissionRequests_Path =
  '/api/web/v1/users/userManagementApplicationPermission/dismissPermissionRequests';

/**
 * Dismiss all currently PENDING permission requests for a UM Company
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_dismissPermissionRequests = (
  getParams: DismissPermissionRequestsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DismissPermissionRequestsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_dismissPermissionRequests_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_Path =
  '/api/web/v1/users/userManagementApplicationPermission/getApplicationManagerForCompany';

/**
 * Get the application manager for the current user's UM Company
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, RentalManagerApplicationManagerWebDto>(
    {
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_Path =
  '/api/web/v1/users/userManagementApplicationPermission/getUserApplicationPermissionStatuses';

/**
 * Get all users and their permission status for a UM Company
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, Array<UserManagementApplicationPermissionUserStatusDto>>(
    {
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_Path =
  '/api/web/v1/users/userManagementApplicationPermission/giveUserApplicationPermission';

/**
 * Give user application permission
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission = (
  getParams: GiveUserApplicationPermissionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GiveUserApplicationPermissionParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_Path =
  '/api/web/v1/users/userManagementApplicationPermission/removeUserApplicationPermission';

/**
 * Remove user's application permission
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission = (
  getParams: RemoveUserApplicationPermissionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RemoveUserApplicationPermissionParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Path =
  '/api/web/v1/users/userManagementApplicationPermission/transferApplicationManager';

/**
 * Transfer application manager role to a new admin
 */
export const RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager = (
  postData: TransferApplicationManagerDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, TransferApplicationManagerDto, void>(
    {
      endpoint: RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
